(function () {
  'use strict';

  /* mr-io-loading.js -- RC3 (2026-07-13), item 5.
     Removes the server-rendered "Loading beneficiary details..." text
     (snippets/mr-c-beneficiary-step.liquid) the moment Infinite Options'
     real fields mount, via MutationObserver -- never a fixed reveal
     timeout. A separate, much longer safety-net timer exists ONLY to
     stop showing the loading message on products that have no real IO
     app block configured at all (e.g. Qurbani/Zabiha) -- it never fakes
     a reveal of fields, it only hides a loading message that would
     otherwise never resolve. The existing CSS in mr-t-product.css
     already collapses the empty IO card itself
     ([id$="__io_app_block"]:not(:has(input,select,textarea,fieldset)));
     this script only prevents the loading text from being the one thing
     left behind when that happens. */

  var GIVE_UP_MS = 8000;

  function hasRealFields(ioBlock) {
    return !!ioBlock.querySelector('input, select, textarea, fieldset');
  }

  function wire(ioBlock) {
    var step = ioBlock.previousElementSibling;
    if (!step || !step.classList || !step.classList.contains('mr-c-beneficiary-step')) return;
    var loadingEl = step.querySelector('[data-mr-io-loading]');
    if (!loadingEl) return;

    function finish() {
      if (loadingEl && loadingEl.parentNode) loadingEl.parentNode.removeChild(loadingEl);
      observer.disconnect();
      clearTimeout(giveUpTimer);
    }

    if (hasRealFields(ioBlock)) {
      finish();
      return;
    }

    var observer = new MutationObserver(function () {
      if (hasRealFields(ioBlock)) finish();
    });
    observer.observe(ioBlock, { childList: true, subtree: true });

    var giveUpTimer = setTimeout(function () {
      if (!hasRealFields(ioBlock)) finish();
    }, GIVE_UP_MS);
  }

  function init(root) {
    root = root || document;
    root.querySelectorAll('[id$="__io_app_block"]').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  window.MRIOLoading = { init: init };
})();
